import { render, staticRenderFns } from "./TableAttachments.vue?vue&type=template&id=75e4a3fc"
import script from "./TableAttachments.vue?vue&type=script&lang=js"
export * from "./TableAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports